import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "left-panel" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-container" }
const _hoisted_4 = { slot: "header" }
const _hoisted_5 = { slot: "body" }

import { ref, computed } from "vue";
import type { FiConfig } from "../types/build";
import { useAuthStore } from "../stores/authStore";
import { logger } from "../utils/logger";
interface Props {
  configData: FiConfig[] | null;
  fiNumber: string | null;
  selectedConfig: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'appConfigLeft',
  props: {
    configData: {},
    fiNumber: {},
    selectedConfig: {}
  },
  emits: ["selected-config", "delete-config"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();

const selectedCardId = ref(null);

const props = __props;

/* global defineEmits */

const emit = __emit;

function getCardClass(build) {
  return build.configId === props.selectedConfig ? "selected-card" : "";
}

const configs = computed(() => {
  const fiData = props.configData;

  logger.debug("🧩 Configs:", fiData);
  if (!fiData) return [];

  return fiData;
});

function onCardClick(build) {
  selectedCardId.value = build.configId;
  emit("selected-config", build.configId); // ✅ emits selected config to FIApps
}
function onDeleteClick(build) {
  const confirmed = window.confirm(
    `Are you sure you want to delete "${build.name}"?`
  );
  if (!confirmed) return;
  logger.debug(`🗑️ Deleting config with ID: ${build.configId}`);
  emit("delete-config", build.configId);
}

return (_ctx: any,_cache: any) => {
  const _component_q2_btn = _resolveComponent("q2-btn")!
  const _component_q2_action_group = _resolveComponent("q2-action-group")!
  const _component_q2_avatar = _resolveComponent("q2-avatar")!
  const _component_q2_item = _resolveComponent("q2-item")!
  const _component_q2_card = _resolveComponent("q2-card")!
  const _component_q2_icon = _resolveComponent("q2-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q2_action_group, {
      "full-width": "true",
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q2_btn, {
          intent: "neutral",
          style: {"visibility":"hidden"}
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Sort", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, {
      name: "card-fade",
      tag: "div",
      class: "cards-wrapper"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configs.value, (config) => {
          return (_openBlock(), _createElementBlock("div", {
            key: config.configId,
            class: _normalizeClass(['card-wrapper', getCardClass(config)]),
            onClick: ($event: any) => (onCardClick(config))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q2_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q2_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q2_avatar, {
                        src: `/v1/configuration/${config.configId}/icon`,
                        icon: "person",
                        slot: "bullet"
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(config.configName), 1),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, _toDisplayString(config.nickName), 1),
                        _createElementVNode("p", null, "Last build on " + _toDisplayString(config.lastBuildFormatted), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            (_unref(authStore).buttons)
              ? (_openBlock(), _createBlock(_component_q2_btn, {
                  key: 0,
                  intent: "workflow-destroy",
                  class: "delete-btn",
                  onClick: _withModifiers(($event: any) => (onDeleteClick(config)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q2_icon, { type: "trash" })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})